import React from 'react'
import PurpleButton from '../buttons/PurpleButton'

const CtaCard = ({ header, text, btnText, btnLink, externalLink }) => {
    return (
        <div className='flex flex-col justify-center items-center px-8 py-[88px] gap-8 bg-white rounded-xl border-t-8 border-brandGreen shadow-strokeCard tablet:px-16 max-w-[1536px] m-auto'>
            <div className='flex flex-col gap-3 text-center'>
                <p className='text-fontSize9 tablet:text-fontSize11-bold'>{header}</p>
                {
                    text && <p className='text-fontSize4 text-brandDarkBlue1 tablet:text-fontSize5'>{text}</p>
                }
            </div>
            <PurpleButton btnText={btnText} btnLink={btnLink} externalLink={externalLink} />
        </div>
    )
}

export default CtaCard